var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path3, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconAstronaut2 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 80,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3691 32C21.5353 32 22.9156 30.6815 22.9156 27.5C22.9156 30.6815 24.2864 32 27.4622 32C24.2864 32 22.9156 33.3567 22.9156 36.5C22.9156 33.3567 21.5353 32 18.3691 32Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.496 60C131.662 60 133.043 58.6815 133.043 55.5C133.043 58.6815 134.413 60 137.589 60C134.413 60 133.043 61.3567 133.043 64.5C133.043 61.3567 131.662 60 128.496 60Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.54,
    cy: 11.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.912,
    cy: 29.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1878,
    cy: 14.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 34.0725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 37.2347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947469,
    cy: 21.678,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 57.6087,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26011,
    cy: 68.1656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7909 36.0547L72.5921 30.2534M69.1118 24.4522L62.1512 31.4062C61.5342 32.0215 61.1869 32.8566 61.1857 33.728C61.1844 34.5993 61.5294 35.4355 62.1446 36.0525C62.7599 36.6695 63.5951 37.0168 64.4664 37.018C64.8979 37.0186 65.3252 36.9343 65.724 36.7697C66.1229 36.6052 66.4854 36.3637 66.7909 36.059L56.35 46.5C55.7632 47.1211 55.442 47.9467 55.4545 48.801C55.4669 49.6554 55.8122 50.4712 56.4168 51.0749C57.0214 51.6787 57.8377 52.0228 58.6921 52.034C59.5464 52.0453 60.3715 51.7229 60.9918 51.1353L66.7909 45.334C67.4064 44.7185 68.2413 44.3727 69.1118 44.3727C69.9824 44.3727 70.8172 44.7185 71.4328 45.334C72.0483 45.9496 72.3941 46.7845 72.3941 47.655C72.3941 48.5255 72.0483 49.3604 71.4328 49.9759L65.6315 55.775C65.016 56.3902 64.67 57.2248 64.6698 58.0951C64.6696 58.9655 65.0152 59.8002 65.6304 60.4157C66.2457 61.0313 67.0803 61.3772 67.9506 61.3774C68.8209 61.3776 69.6557 61.0321 70.2712 60.4168L80.7121 49.9759M69.1118 24.4522C69.7212 23.8427 70.4447 23.3592 71.241 23.0293C72.0373 22.6994 72.8907 22.5297 73.7526 22.5297C74.6145 22.5297 75.468 22.6994 76.2642 23.0293C77.0605 23.3592 77.784 23.8427 78.3934 24.4522L92.3147 38.3734C92.9242 38.9828 93.4076 39.7063 93.7375 40.5026C94.0674 41.2988 94.2372 42.1523 94.2372 43.0142C94.2372 43.8761 94.0674 44.7295 93.7375 45.5258C93.4076 46.3221 92.9242 47.0456 92.3147 47.655M69.1118 24.4522L77.2318 16.3322C77.6887 15.8749 78.2313 15.5121 78.8284 15.2646C79.4256 15.017 80.0657 14.8896 80.7121 14.8896C81.3586 14.8896 81.9987 15.017 82.5959 15.2646C83.193 15.5121 83.7356 15.8749 84.1925 16.3322L85.96 18.0975M92.3147 47.655L85.354 54.6156C84.7388 55.2311 83.9042 55.5771 83.0339 55.5773C82.1635 55.5775 81.3288 55.2319 80.7132 54.6167C80.0977 54.0014 79.7518 53.1668 79.7516 52.2965C79.7514 51.4262 80.0969 50.5915 80.7121 49.9759M92.3147 47.655L100.435 39.535C100.892 39.0781 101.255 38.5355 101.502 37.9384C101.75 37.3412 101.877 36.7011 101.877 36.0547C101.877 35.4082 101.75 34.7681 101.502 34.171C101.255 33.5738 100.892 33.0312 100.435 32.5743L98.6671 30.8068M80.7121 49.9759L86.5134 44.1747M97.499 31.9684C97.0667 28.7357 95.6631 25.7104 93.474 23.2928C91.0575 21.1005 88.0321 19.6938 84.7984 19.259M74.6287 56.0593L75.8734 57.49C77.6548 59.535 79.8476 61.1812 82.3084 62.3211C84.7693 63.461 87.443 64.0689 90.1548 64.1053C92.8667 64.1416 95.5557 63.6055 98.0462 62.5319C100.537 61.4584 102.773 59.8715 104.608 57.875M82.7093 25.0318C82.7093 27.425 83.66 29.7202 85.3522 31.4124C87.0445 33.1046 89.3396 34.0553 91.7328 34.0553C94.1259 34.0553 96.4211 33.1046 98.1133 31.4124C99.8055 29.7202 100.756 27.425 100.756 25.0318C100.756 22.6387 99.8055 20.3435 98.1133 18.6513C96.4211 16.9591 94.1259 16.0084 91.7328 16.0084C89.3396 16.0084 87.0445 16.9591 85.3522 18.6513C83.66 20.3435 82.7093 22.6387 82.7093 25.0318ZM78.3934 33.7337L83.0331 38.3734L78.3956 43.0153L73.7537 38.3734L78.3934 33.7337Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 80,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3691 32C21.5353 32 22.9156 30.6815 22.9156 27.5C22.9156 30.6815 24.2864 32 27.4622 32C24.2864 32 22.9156 33.3567 22.9156 36.5C22.9156 33.3567 21.5353 32 18.3691 32Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.496 60C131.662 60 133.043 58.6815 133.043 55.5C133.043 58.6815 134.413 60 137.589 60C134.413 60 133.043 61.3567 133.043 64.5C133.043 61.3567 131.662 60 128.496 60Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.54,
    cy: 11.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.912,
    cy: 29.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1878,
    cy: 14.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 34.0725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 37.2347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947469,
    cy: 21.678,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 57.6087,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26011,
    cy: 68.1656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.7909 36.0547L72.5921 30.2534M69.1118 24.4522L62.1512 31.4062C61.5342 32.0215 61.1869 32.8566 61.1857 33.728C61.1844 34.5993 61.5294 35.4355 62.1446 36.0525C62.7599 36.6695 63.5951 37.0168 64.4664 37.018C64.8979 37.0186 65.3252 36.9343 65.724 36.7697C66.1229 36.6052 66.4854 36.3637 66.7909 36.059L56.35 46.5C55.7632 47.1211 55.442 47.9467 55.4545 48.801C55.4669 49.6554 55.8122 50.4712 56.4168 51.0749C57.0214 51.6787 57.8377 52.0228 58.6921 52.034C59.5464 52.0453 60.3715 51.7229 60.9918 51.1353L66.7909 45.334C67.4064 44.7185 68.2413 44.3727 69.1118 44.3727C69.9824 44.3727 70.8172 44.7185 71.4328 45.334C72.0483 45.9496 72.3941 46.7845 72.3941 47.655C72.3941 48.5255 72.0483 49.3604 71.4328 49.9759L65.6315 55.775C65.016 56.3902 64.67 57.2248 64.6698 58.0951C64.6696 58.9655 65.0152 59.8002 65.6304 60.4157C66.2457 61.0313 67.0803 61.3772 67.9506 61.3774C68.8209 61.3776 69.6557 61.0321 70.2712 60.4168L80.7121 49.9759M69.1118 24.4522C69.7212 23.8427 70.4447 23.3592 71.241 23.0293C72.0373 22.6994 72.8907 22.5297 73.7526 22.5297C74.6145 22.5297 75.468 22.6994 76.2642 23.0293C77.0605 23.3592 77.784 23.8427 78.3934 24.4522L92.3147 38.3734C92.9242 38.9828 93.4076 39.7063 93.7375 40.5026C94.0674 41.2988 94.2372 42.1523 94.2372 43.0142C94.2372 43.8761 94.0674 44.7295 93.7375 45.5258C93.4076 46.3221 92.9242 47.0456 92.3147 47.655M69.1118 24.4522L77.2318 16.3322C77.6887 15.8749 78.2313 15.5121 78.8284 15.2646C79.4256 15.017 80.0657 14.8896 80.7121 14.8896C81.3586 14.8896 81.9987 15.017 82.5959 15.2646C83.193 15.5121 83.7356 15.8749 84.1925 16.3322L85.96 18.0975M92.3147 47.655L85.354 54.6156C84.7388 55.2311 83.9042 55.5771 83.0339 55.5773C82.1635 55.5775 81.3288 55.2319 80.7132 54.6167C80.0977 54.0014 79.7518 53.1668 79.7516 52.2965C79.7514 51.4262 80.0969 50.5915 80.7121 49.9759M92.3147 47.655L100.435 39.535C100.892 39.0781 101.255 38.5355 101.502 37.9384C101.75 37.3412 101.877 36.7011 101.877 36.0547C101.877 35.4082 101.75 34.7681 101.502 34.171C101.255 33.5738 100.892 33.0312 100.435 32.5743L98.6671 30.8068M80.7121 49.9759L86.5134 44.1747M97.499 31.9684C97.0667 28.7357 95.6631 25.7104 93.474 23.2928C91.0575 21.1005 88.0321 19.6938 84.7984 19.259M74.6287 56.0593L75.8734 57.49C77.6548 59.535 79.8476 61.1812 82.3084 62.3211C84.7693 63.461 87.443 64.0689 90.1548 64.1053C92.8667 64.1416 95.5557 63.6055 98.0462 62.5319C100.537 61.4584 102.773 59.8715 104.608 57.875M82.7093 25.0318C82.7093 27.425 83.66 29.7202 85.3522 31.4124C87.0445 33.1046 89.3396 34.0553 91.7328 34.0553C94.1259 34.0553 96.4211 33.1046 98.1133 31.4124C99.8055 29.7202 100.756 27.425 100.756 25.0318C100.756 22.6387 99.8055 20.3435 98.1133 18.6513C96.4211 16.9591 94.1259 16.0084 91.7328 16.0084C89.3396 16.0084 87.0445 16.9591 85.3522 18.6513C83.66 20.3435 82.7093 22.6387 82.7093 25.0318ZM78.3934 33.7337L83.0331 38.3734L78.3956 43.0153L73.7537 38.3734L78.3934 33.7337Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});
export default SvgIconAstronaut2;
export const raw = __webpack_public_path__ + "static/media/icon-astronaut-2.55e1bf9d6afcb1bd091b565a3aba7692.svg";